import CategoriaProdutoServicoService from "../../services/CategoriaProdutoServicoService";
import FormSelectSearchModal from "../forms/base/FormSelectSearchModal";
import FormCategoriaProdutoServico from "../../pages/CategoriaProdutoServico/FormCategoriaProdutoServico";
import Permissao from "../../controllers/Permissao";

export default class SelectCategoriaProdutoServico extends FormSelectSearchModal {

    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);

        this.state.showBtns = this.props.showBtns === undefined ? true : this.props.showBtns;
        this.state.showBtnSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
        this.state.showBtnNewForm = this.state.showBtns && ((this.props.showBtnNewForm === undefined ? true : false) && Permissao.getInstance().getPermissao(16));
        this.state.showBtnNewSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
    }

    getConfigFormNew() {
        return {
            title: 'Cadastro de Categoria de Produto / Serviço',
            sizeModal: 'modal-xl',
            config: {
                isModal: true
            },
            form: FormCategoriaProdutoServico,
            onSave: (response) => {
                this.getOptions(() => {
                    if (response.data?.idCategoriaProdutoServico) {
                        this.handleOpenSearch(null, response.data?.idCategoriaProdutoServico);
                    } else {
                        this.handleOpenSearch();
                    }
                });
            },
            onClose: () => {
                //this.handleOpenSearch();
            }
        };
    };

    componentDidMount() {
        super.componentDidMount();
        this.getOptions(() => {
            if (this.dispachChangeDidMount && this.props.value) {
                this.handleChange({ target: { value: this.props.value, name: this.props.name } });
            }
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {
        CategoriaProdutoServicoService.getForCombo((response) => {
            this.setState({ options: response }, () => {
                if (callBack) {
                    callBack();
                }
            });
        });
    }

    render() {
        return super.render();
    }
}